import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
export const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Handle hash links correctly across pages
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    if (href.startsWith('#')) {
      e.preventDefault();
      setMobileMenuOpen(false);
      if (location.pathname !== '/') {
        // If not on home page, navigate to home then scroll
        navigate(`/${href}`);
      } else {
        // If already on home page, just scroll
        const element = document.querySelector(href);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }
    } else {
      setMobileMenuOpen(false);
    }
  };
  const navLinks = [{
    name: 'Avant / Après',
    href: '/avant-apres'
  }, {
    name: 'Tarifs',
    href: '/tarifs'
  }, {
    name: 'Technologie laser',
    href: '/technologie-laser'
  }, {
    name: 'FAQ',
    href: '/faq'
  }, {
    name: 'Contact',
    href: '/contact'
  }];
  const Logo = () => <Link to="/" className="block cursor-pointer" onClick={() => setMobileMenuOpen(false)} data-id="element-123">
      <img src="https://cdn.magicpatterns.com/uploads/8UGBnXPL8tFE9Y31LhhwcB/Dispel_Blanc.svg" alt="Dispel Your Tattoo" className="h-12 md:h-16 w-auto" data-id="element-124" />
    </Link>;
  return <>
      <motion.nav initial={{
      y: -100
    }} animate={{
      y: 0
    }} transition={{
      duration: 0.8,
      ease: [0.16, 1, 0.3, 1]
    }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-brand-dark/95 backdrop-blur-md py-3 border-b border-brand-border/50' : 'bg-gradient-to-b from-brand-darker/70 via-brand-darker/30 to-transparent py-4 md:py-5'}`} data-id="element-125">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-126">
          <Logo data-id="element-127" />

          {/* Desktop Nav */}
          <div className="hidden lg:flex items-center space-x-6 xl:space-x-8" data-id="element-128">
            {navLinks.map(link => link.href.startsWith('#') ? <a key={link.name} href={link.href} onClick={e => handleNavClick(e, link.href)} className="text-xs font-medium text-brand-light/80 hover:text-brand-light transition-colors duration-300 uppercase tracking-[0.15em]" data-id="element-129">
                  {link.name}
                </a> : <Link key={link.name} to={link.href} className={`text-xs font-medium transition-colors duration-300 uppercase tracking-[0.15em] ${location.pathname === link.href ? 'text-brand-light' : 'text-brand-light/80 hover:text-brand-light'}`} data-id="element-130">
                  {link.name}
                </Link>)}
          </div>

          {/* Desktop CTA */}
          <div className="hidden lg:flex items-center" data-id="element-131">
            <Link to="/contact#consultation-form" onClick={() => setMobileMenuOpen(false)} className="px-6 py-2.5 rounded-full bg-brand-light text-brand-dark text-xs font-bold hover:bg-brand-light/20 hover:text-brand-light border border-brand-light transition-all duration-300 uppercase tracking-wider" data-id="element-132">
              Demander un devis
            </Link>
          </div>

          {/* Mobile Toggle */}
          <button className="lg:hidden text-brand-light p-2 -mr-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-133">
            {mobileMenuOpen ? <X size={28} data-id="element-134" /> : <Menu size={28} data-id="element-135" />}
          </button>
        </div>
      </motion.nav>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-136">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} className="fixed inset-0 z-40 bg-brand-darker pt-24 px-6 flex flex-col h-screen overflow-y-auto" data-id="element-137">
            <div className="flex flex-col space-y-4 md:space-y-6 text-lg md:text-xl font-bold uppercase tracking-widest mt-8" data-id="element-138">
              {navLinks.map(link => link.href.startsWith('#') ? <a key={link.name} href={link.href} onClick={e => handleNavClick(e, link.href)} className="text-brand-light border-b border-brand-border/30 pb-4" data-id="element-139">
                    {link.name}
                  </a> : <Link key={link.name} to={link.href} onClick={() => setMobileMenuOpen(false)} className={`border-b border-brand-border/30 pb-4 ${location.pathname === link.href ? 'text-brand-light' : 'text-brand-light/80'}`} data-id="element-140">
                    {link.name}
                  </Link>)}
            </div>
            <div className="mt-auto mb-12 pt-8 flex flex-col space-y-4" data-id="element-141">
              <Link to="/contact#consultation-form" onClick={() => setMobileMenuOpen(false)} className="flex items-center justify-center w-full py-4 rounded-full bg-brand-light text-brand-dark font-bold uppercase tracking-wider text-sm md:text-base" data-id="element-142">
                Réserver une consultation
              </Link>
            </div>
          </motion.div>}
      </AnimatePresence>
    </>;
};